import type { GraphQLFormattedError } from 'graphql';
import Logger from '../../utils/Logger';
import normalizeGraphQLError from '../../utils/error/normalizeGraphQLError';

const getErrorMessage = (
  error: { graphQLErrors: readonly GraphQLFormattedError[] } | null | undefined,
  entity: string,
) => {
  const errorCode = error?.graphQLErrors?.[0]
    ? normalizeGraphQLError(error.graphQLErrors[0]).code
    : null;

  if (!errorCode) {
    return null;
  }

  const messages = {
    TOKEN_INVALID: `We could not validate the ${entity}.`,
    TOKEN_REUSE: `It seems like this ${entity} has been used.`,
    TOKEN_OLD: `A newer ${entity} was requested.`,
    TOKEN_EXPIRED: `This ${entity} has expired.`,
  };

  const message = messages[errorCode as keyof typeof messages];

  if (message) return message;

  Logger.warn(`Unknown error code for showing message: ${errorCode}`);
  return 'Something went wrong.';
};

export default getErrorMessage;
